module.exports = __webpack_public_path__ + "img/png4.65536858.png";